export enum TipoPedidoEnum {
  RENOVACAO_REGISTRO_VEICULO =  "Renovação do Registro de Veículo",
  INCLUSAO_VEICULO =  "Inclusão Veículo",
  EXCLUSAO_VEICULO =  "Exclusão Veículo",
  RENOVACAO_CADASTRO_TRANSPORTADORA = "Renovação Cadastro de Transportadora",
  CADASTRO_TRANSPORTADORA = "Cadastro Transportadora",
  SUBSTITUICAO_COOPERADO = "Substituição de Cooperado",
}
